import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { manageFootballSeasonService } from "../../../../../commons";
import { Stadium } from "../../../../../commons/models/stadium";
import { PaginatedEnsueCollection } from "../../../../../ensue-react-system/utilities/paginated-ensue-collection";

export interface IManageSeasonStadiumsOption {
  seasonId: number;
  urlParams?: {
    hostTeamId?: number;
    page?: number;
    perPage?: number;
    sort?: string;
    sortOrder?: "DESC" | "ASC";
    name?: string;
  };
}

export interface IFootballManageSeasonStadiumsState {
  manageSeasonStadiums: PaginatedEnsueCollection<Stadium>;
  manageSeasonStadiumsStatus: StatusEnum;
}

const initialState: IFootballManageSeasonStadiumsState = {
  manageSeasonStadiums: new PaginatedEnsueCollection<Stadium>(),
  manageSeasonStadiumsStatus: StatusEnum.Idle,
};

export const fetchManageSeasonStadiums = createAsyncThunk(
  "manageSeasonStadiums/fetchManageSeasonStadiums",
  async (options: IManageSeasonStadiumsOption, thunkAPI) => {
    try {
      const manageSeasonStadiums = await manageFootballSeasonService.getSeasonStadiums(
        options.seasonId,
        options.urlParams
      );
      return manageSeasonStadiums;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageSeasonStadiumsSlice = createSlice({
  name: "footballManageSeasonStadiums",
  initialState: initialState,
  reducers: {
    cleanUpSeasonStadiums(state) {
      state.manageSeasonStadiums = new PaginatedEnsueCollection<Stadium>();
      state.manageSeasonStadiumsStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageSeasonStadiums.pending, (state) => {
        state.manageSeasonStadiumsStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageSeasonStadiums.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<Stadium>>) => {
          state.manageSeasonStadiumsStatus = StatusEnum.Succeeded;
          state.manageSeasonStadiums = action.payload;
        }
      )
      .addCase(fetchManageSeasonStadiums.rejected, (state) => {
        state.manageSeasonStadiumsStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpSeasonStadiums } = footballManageSeasonStadiumsSlice.actions;
export default footballManageSeasonStadiumsSlice.reducer;
